import { render, staticRenderFns } from "./anumbersform.vue?vue&type=template&id=333c1804&"
import script from "./anumbersform.vue?vue&type=script&lang=ts&"
export * from "./anumbersform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports